import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

const EmptyProgramCourseList: React.FC = () => {
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);

    return (
        <div className="empty-program-course-list">
            <i className="material-icons-outlined align-middle" id="file">
                {Constants.icons.BALLOT}
            </i>
            <h1>{strings.PROGRAM_COURSE_LIST_EMPTY_STATE}</h1>
            <p>{strings.PROGRAM_COURSE_LIST_EMPTY_STATE_INSTRUCTION}</p>
        </div>
    );
};

export default EmptyProgramCourseList;
